import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  CircularProgress,
  Checkbox,
  Radio,
  FormControl,
  FormControlLabel,
  RadioGroup,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { TextField, Button, Tooltip, Typography } from '@material-ui/core';
import ChevronRight from '@material-ui/icons/ChevronRight';
import PropTypes, { object } from 'prop-types';
import React, { useState, useContext, useEffect } from 'react';
import { withRouter } from 'react-router';
import { Autocomplete } from '../../../Autocomplete';
import Select, { components } from 'react-select';
import cn from 'classnames';
import styles from './QaDetailRestrictions.styles';
import { AppContext } from '../../../../AppContext';
import SearchIcon from '@material-ui/icons/Search';
import Error from '@material-ui/icons/Error';

import ColoredCheckbox from '../../../ColoredInputs/ColoredCheckbox';
import ColoredRadio from '../../../ColoredInputs/ColoredRadio';
import ColoredSwitch from '../../../ColoredInputs/ColoredSwitch';
import InfoTooltip from '../../../InfoTooltip';
import { ConfirmationDialog } from '../../../ConfirmationDialog';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from '@material-ui/core/styles';
import { getQaUserPermissionsById , saveQaPermissions } from '../../../../services/userPermissions.service';
import { getQaUserById, getQaUserPermissions } from '../../../../services';
import Loading from '../../../Loading/Loading';
import { QaDetailContext } from '../QaDetailContext';

const useStyles = makeStyles({
  confirmationModal: {
    width: '90vw',
  },
});


let counter = 0;
const ValueContainer = React.memo(({ children, getValue, ...props }) => {
  counter = getValue().length + ' selected';

  return <components.ValueContainer {...props}>{children}</components.ValueContainer>;
});

export const QaDetailRestrictionsTab = withStyles(styles)(({ classes, ...props }) => {
  //list variables
  const [products, setProducts] = useState([]);
  const [supplements, setSupplements] = useState([]);
  const [columnData, setColumnData] = useState([]);
  const [supplementData, setSupplementData] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);
  const [clientPriceOverrides, setClientPriceOverrides] = useState({});
  const [qaProductPermissions, setQaProductPermissions] = useState({});

  // loading
  const [productsLoading, setProductsLoading] = useState(true);
  const [clientOptionsLoading, setClientOptionsLoading] = useState(false);
  const [QaProductsLoading, setQaProductsLoading] = useState(true);
  const [formIsSaving, setFormIsSaving] = useState(false);
  const [formLoading, setFormLoading] = useState(true);

  // selected variables
  const [selectedPropertyTypeId, setSelectedPropertyTypeId] = useState(null);
  const [selectedProductCategoryId, setSelectedProductCategoryId] = useState(null);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [selectedClient, setSelectedClient] = useState(
    null,
    // {
    //   label: 'Cincinnati Insurance (Personal Lines) (CICTE)',
    //   value: 102,
    // },
  );
  const [selectedSupplementName, setSelectedSupplementName] = useState(null);
  const [selectedFormHeaderId, setSelectedFormHeaderId] = useState(null);


  // QA changes 
  const [selectedQa, setSelectedQa] = useState(null,);


  let [errorType, setErrorType] = useState([]);
  let [errorCategory, setErrorCategory] = useState([]);
  let [errorName, setErrorName] = useState([]);

  const [selectedClients, setSelectedClients] = useState([]);
  const [filteredNameColumnData, setFilteredNameColumnData] = useState([]);
  const [filteredSupplementData, setFilteredSupplementData] = useState([]);
  const [filteredCategoryColumnData, setFilteredCategoryColumnData] = useState([]);
  const [filteredCategorySupplementData, setFilteredCategorySupplementData] = useState([]);

  const [wipeUpdateCreate, SetwipeUpdateCreate] = useState(false);
  const [clearCreate, setClearCreate] = useState(false);
  const [updateCreate, setUpdateCreate] = useState(true);
  // control whether the form is in client edit mode or JMI default edit mode
  const [qaSingleSelectEnabled, setqaSingleSelectEnabled] = useState(true);

  // control whether the form is in selected products only mode
  const [selectProduct, setSelectProduct] = useState(true);

  // control whether client is looking at supplements or products
  const [supplementView, setSupplementView] = useState(false);

  // track modified answer values for the current question
  const [validProductIds, setValidProductIds] = useState(new Set());
  const [validFormHeaderIds, setValidFormHeaderIds] = useState(new Set());
  const [activeProduct, setActiveProduct] = useState(null);

  // control the save changes modal
  const [showSaveChangesModal, setSaveChangesModal] = useState(false);
  const [saveChanges, setSaveChanges] = useState(false);
  const [changes, setChanges] = useState({});

  const [showSelectAll, setShowSelectAll] = useState(true);

  // const [testData, setTestData] = useContext();
  /**
   * COMPUTED
   */
  // const formIsReady = !!selectedClient || selectedClients.length;

  
  const { dispatch, contextValue } = useContext(AppContext);

  const {
    state: { profile,restrictions, permissions },
    dispatch : dispatchQa,
  } = useContext(QaDetailContext);

  const formIsReady = true;
  const formIsLoading =  (productsLoading || QaProductsLoading )  && !profile && !restrictions && !permissions;

  /*
    * FUNCTIONS
  */

  

  const handleSaveChangesButton = async ()=>{
    setSaveChanges(true);
    const flattened = flattenColumnData();

    const vm = {

      EntityId: [selectedQa.value],
      validProducts: flattened
        .filter(product => validProductIds.has(product.productId)).map(x=>{
          return x.productId;
        })
    }
    try {
      const success = await saveQaPermissions(vm);

      dispatchQa({
        type: 'UPDATE_RESTRICTIONS',
        restrictions: flattened
        .filter(product => validProductIds.has(product.productId))
        .map(x=>{
          return x.productId;
        }),
      });
      
      dispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'success',
          message: 'Permissions saved successfully!',
        },
      });
      if(qaSingleSelectEnabled){
        setupInitialQaState();
      }

    }catch (error){
      dispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'error',
          message: typeof error === 'string' ? error : error.message || 'Permissions failed to save...',
        },
      });

    }
    createColumnData(vm.validProducts)
    setSaveChanges(false);
    setSaveChangesModal(false);
    setChanges(vm)
  };

  const handleSaveModal = () =>{
    setSaveChangesModal(true);
    const flattened = flattenColumnData();

    const vm = {
      
      EntityId: [selectedQa.value],
      validProducts: flattened
      .filter(product => validProductIds.has(product.productId))
      ?.sort((a, b) => a.productCode.localeCompare(b.productCode)),
        
    }
    setChanges(vm);
  }

  const flattenColumnData =() =>{
    const flattened = Object.keys(columnData)
      .map(propertyTypeName =>{
        return Object.keys(columnData[propertyTypeName]).map(
          productCategoryName => columnData[propertyTypeName][productCategoryName],
        );
      })
      .flat()
      .flat();
      return flattened;
  }

  const toggleqaSingleSelectEnabled = evt => {
    const newStatus = evt.target.checked;

    if(newStatus){
      setSelectedQa()
    }
  };
  const getProductsAsync = async () => {
    try {
      setProductsLoading(true);
      const products = await getQaUserPermissions();
      setProducts(products);
    } catch (error) {
      console.log(error);
    }
    setProductsLoading(false);
  };

  const getProductsByQaAsync = async (userId) => {
    try {
        setProductsLoading(true);
        const permissions = await getQaUserPermissionsById(userId);
        setQaProductPermissions(permissions);
    } catch (error) {
        console.log(error);

    };  
    setProductsLoading(false);
};
const getSelectedQaUser = async (userId) => {
    try {
        setProductsLoading(true);
        const user = await getQaUserById(userId);
        setSelectedQa({
            label: user.name,
            value: user.qaId,
        });
    } catch (error) {
        console.log(error);
    };
    setProductsLoading(false);
};

const resetColumnSelections = () => {
    setSelectedPropertyTypeId(null);
    setSelectedProductCategoryId(null);
    setSelectedProductId(null);

}


const createColumnData = (permissions = []) => {
  setFormLoading(true);
    const validIds = permissions.map(product => product);
    
    // generate column data
    const formattedColumnData = products.reduce((acc, cur) => {
      if (!acc[cur.propertyTypeName]) acc[cur.propertyTypeName] = {};

      if (!acc[cur.propertyTypeName][cur.productCategoryName]) acc[cur.propertyTypeName][cur.productCategoryName] = [];

      acc[cur.propertyTypeName][cur.productCategoryName].push(
        qaSingleSelectEnabled
          ? {
              ...cur,
              ...permissions.find(({ productId }) => productId === cur),
            }
          : cur,
      );

      return acc;
    }, {});
    setColumnData(formattedColumnData);
    setFilteredCategoryColumnData(formattedColumnData);
    setFilteredNameColumnData(formattedColumnData);
    setValidProductIds(new Set(validIds));
    setFormLoading(false);
};

const productsById = async qaId =>{
  try{
    setQaProductsLoading(true);
    const qaProducts = await getQaUserPermissionsById(qaId);
    setQaProductsLoading(false);
    return qaProducts; 
  }catch(error){
    console.log(error)
    setQaProductsLoading(false)
    return [];
  }

}

const setupInitialQaState = async () => {
  resetColumnSelections();
        if(selectedQa){
          if(profile && restrictions && permissions){
            
            createColumnData(restrictions);
          }else{

            const stuff = await productsById(selectedQa.value);
            createColumnData(stuff)
          }
      }else{
        
      }
      
}
const toggleSelectProductEnabled = evt => {
  const newStatus = evt.target.checked;

  setSelectProduct(newStatus);
};

/*
* FUNCTIONS: Rendering
*/
const getProductNameIndex = (propertyTypeId, productCategoryId, productId) =>
  columnData[propertyTypeId][productCategoryId].findIndex(cat => cat.productId === productId);


const handleProductNameCheckboxChange = productId => evt => {
  // toggle checked status
  if (validProductIds.has(productId)) {
    validProductIds.delete(productId);

    const { propertyTypeName, productCategoryName } = products.find(product => product.productId === productId);
    const productNameIndex = getProductNameIndex(propertyTypeName, productCategoryName, productId);

    const updatedColumnData = JSON.parse(JSON.stringify({ ...columnData }));

    updatedColumnData[propertyTypeName][productCategoryName][productNameIndex] = {
      ...updatedColumnData[propertyTypeName][productCategoryName][productNameIndex],
      tier1: '',
      tier2: '',
      tier3: '',
    };

    setColumnData(updatedColumnData);
    setFilteredCategoryColumnData(updatedColumnData);
    setFilteredNameColumnData(updatedColumnData);
  } else {
    validProductIds.add(productId);
  }
};


const handleProductSelectAll = (productIds,result) => evt =>{

  if(result){
    for(const value of productIds){
      if (validProductIds.has(value)) {
        validProductIds.delete(value);
        
    
        const { propertyTypeName, productCategoryName } = products.find(product => product.productId === value);
        const productNameIndex = getProductNameIndex(propertyTypeName, productCategoryName, value);
    
        const updatedColumnData = JSON.parse(JSON.stringify({ ...columnData }));
    
        updatedColumnData[propertyTypeName][productCategoryName][productNameIndex] = {
          ...updatedColumnData[propertyTypeName][productCategoryName][productNameIndex],
        };
    
        setColumnData(updatedColumnData);
        setFilteredCategoryColumnData(updatedColumnData);
        setFilteredNameColumnData(updatedColumnData);
      } 
  }
} else{
  for(const value of productIds){
    if (!validProductIds.has(value)) {
      validProductIds.add(value);
      
  
      const { propertyTypeName, productCategoryName } = products.find(product => product.productId === value);
      const productNameIndex = getProductNameIndex(propertyTypeName, productCategoryName, value);
  
      const updatedColumnData = JSON.parse(JSON.stringify({ ...columnData }));
  
      updatedColumnData[propertyTypeName][productCategoryName][productNameIndex] = {
        ...updatedColumnData[propertyTypeName][productCategoryName][productNameIndex],
      };
  
      setColumnData(updatedColumnData);
      setFilteredCategoryColumnData(updatedColumnData);
      setFilteredNameColumnData(updatedColumnData);
    } 
    
  }
}
  
  
}

const renderCell = ({
    title,
    subtitle,
    isSelected,
    isError = false,
    count = null,
    columnDisabled,
    key,
    onClick,
    showCheckbox = false,
    checked,
    onCheckboxClick,
    hasNext=true,
    disabled = false,
    selectAll = false,
}) => {
    return (
        <div
          key={key}
          className={cn(
            classes.columnTile,
            isSelected && classes.columnTileSelected,
            columnDisabled && classes.columnDisabled,
          )}
          onClick={onClick}
        >
          <div className={cn('row-between-center')}>
            {showCheckbox && (
              <ColoredCheckbox
                //
                style={{ marginRight: 15 }}
                checked={checked}
                onClick={onCheckboxClick}
              />
            )}
  
            <section className={cn('col-center-start text-left')}>
              <div>{title}</div>
              {subtitle && <div style={{ fontSize: '0.8em', color: isSelected ? null : '#AAA' }}>{subtitle}</div>}
            </section>
          </div>
            
          <div>
            {isError == true && <Error style={{ color: 'red' }} />}
            {hasNext?<ChevronRight />: null}
          </div>
        </div>
      ); 
}

const renderPropertyTypeCell = (name, index) => {
    let typeName = name;
    // if(supplementView){
    //     if(name === 1){
    //         typeName = 'Residential';
    //     } else if(name === 2){
    //         typeName = 'Commercial';
    //     }
    // }

    const isSelected = typeName === selectedPropertyTypeId;
    const columnDisabled = !formIsReady;

    const onClick = () => {
        setSelectedProductId(null);
      setSelectedProductCategoryId(null);
      setSelectedPropertyTypeId(name);
    };

    return renderCell({
        title: typeName,
        isSelected,
        isError: errorType.includes(name),
        columnDisabled,
        key: `property-type-${name}`,
        onClick,
      });
};
const renderProductCategoryCell = (name, index) => {
    const isSelected = name === selectedProductCategoryId;
    const columnDisabled = !formIsReady;

    const onClick = () => {
      setSelectedProductId(null);
      setSelectedProductCategoryId(name);
    };

    return renderCell({
      title: name,
      isError: errorCategory.includes(name),
      isSelected,
      columnDisabled,
      key: `product-category-${selectedPropertyTypeId}-${name}`,
      onClick,
    });
};
  
const renderProductNameCell = (product, index) => {
    const { productId, productName, productCode } = product;

    const isSelected = productId === selectedProductId;
    

    const onClick = () => {
      setSelectedProductId(productId);
    };

    const isCheckboxChecked = validProductIds.has(product.productId);

    return renderCell({
      title: productCode,
      subtitle: productName,
      isError: errorName.includes(productId.toString()),
      isSelected,
      columnDisabled: false,
      key: `product-${selectedPropertyTypeId}-${selectedProductCategoryId}-${productId}`,
      onClick,
      showCheckbox: true,
      checked: isCheckboxChecked,
      onCheckboxClick: handleProductNameCheckboxChange(product.productId),
      hasNext: false,
    });
};

const runCategoriesFilter = event => {
  const prodNameFilter = document?.getElementById('productNameFilter').value.toUpperCase() ?? '';
  const prodCategoriesFilter = document?.getElementById('productCategoriesFilter').value.toUpperCase() ?? '';

  const returnedData = Object.entries(columnData)
    ?.map(([TypeKey, TypeValue]) => {
      TypeValue = Object.entries(TypeValue)
        ?.filter(([CategoryKey, CategoryValue]) => {
          //console.log(key);
          return CategoryKey?.toUpperCase()?.includes(prodCategoriesFilter);
        })
        ?.reduce((accCategory, [CategoryKey, CategoryValue]) => {
          accCategory[CategoryKey] = CategoryValue;
          return accCategory;
        }, {});
      return [TypeKey, TypeValue];
    })
    ?.reduce((accType, [TypeKey, TypeValue]) => {
      accType[TypeKey] = TypeValue;
      return accType;
    }, {});
  setFilteredCategoryColumnData(returnedData);
};

const runNameFilter = event => {
  const prodNameFilter = document?.getElementById('productNameFilter').value.toUpperCase() ?? '';

  const returnedData = Object.entries(columnData)
    ?.map(([TypeKey, TypeValue]) => {
      TypeValue = Object.entries(TypeValue)
        ?.map(([CategoryKey, CategoryValue]) => {
          CategoryValue = Object.entries(CategoryValue)
            ?.filter(([NameKey, NameValue]) => {
              const { productCode } = NameValue;
              return productCode?.toUpperCase()?.includes(prodNameFilter);
            })
            ?.reduce((accName, [NameKey, NameValue]) => {
              accName.push(NameValue);
              return accName;
            }, []);
          return [CategoryKey, CategoryValue];
        })
        ?.reduce((accCategory, [CategoryKey, CategoryValue]) => {
          accCategory[CategoryKey] = CategoryValue;
          return accCategory;
        }, {});
      return [TypeKey, TypeValue];
    })
    ?.reduce((accType, [TypeKey, TypeValue]) => {
      accType[TypeKey] = TypeValue;
      return accType;
    }, {});
  setFilteredNameColumnData(returnedData);
};

const renderSelectAllCell = (product,index)=>{

  const allProductIdsInCategory = product.map(x=>x.productId);
 


  let isCheckboxChecked = true;
  for(const value of allProductIdsInCategory){
    if(!validProductIds.has(value)){
       isCheckboxChecked = false;
    }
  }
  if(allProductIdsInCategory.length === 0){
    isCheckboxChecked = false;
  }
  

  // return renderCell({
  //   title: "Select all",
  //   isSelected: false,
  //   columnDisabled: false,
  //   key: `product-${selectedPropertyTypeId}-${selectedProductCategoryId}-selectAll`,
  //   onClick,
  //   showCheckbox: true,
  //   checked: isCheckboxChecked,
  //   onCheckboxClick: handleProductSelectAll(allProductIdsInCategory, isCheckboxChecked),
  //   hasNext: false,
  // });

  return <div className={cn('col-between-center')}>
  
    <ColoredCheckbox
      //
      style={{ marginRight: 15 }}
      checked= {isCheckboxChecked}
      onClick={handleProductSelectAll(allProductIdsInCategory, isCheckboxChecked)}
    />
  

  {/* <section className={cn('col-center-start text-left ')}>
    
  </section> */}
</div>
}

  useEffect(() => {
      setupInitialQaState();
  }, [selectedQa]);

  useEffect(() => { 
    if(profile && restrictions && permissions){
      setProducts(permissions);
      setSelectedQa({
        label: profile.name,
        value: profile.qaId,
      });
        setQaProductPermissions(restrictions);
    } 
    
  }, [profile, restrictions, permissions]);

  return (
    <>
      
      {(formIsLoading) && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'absolute',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.3)',
              zIndex: 99,
            }}
          >
            <Loading size={100} style={{ position: 'absolute', top: 200, color: 'white' }} />
          </div>
        )}

        
    
      <Grid item xs={12} className={classes.container}>
        <Card className={cn('flex-1', 'flex-column')}>
          <CardHeader
            className={classes.cardHeader}
            titleTypographyProps={{ className: classes.cardHeaderTitle }}
            title={
              <div className="row-between-center">
                <div>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSaveModal}
                    disabled={
                      !formIsReady || errorType.length > 0 || (!qaSingleSelectEnabled && counter === '0 selected')
                    }
                    className={cn('light-blue-background')}
                    style={{
                      marginRight: 10,
                      opacity:
                        !formIsReady || (!qaSingleSelectEnabled && counter === '0 selected') || errorType.length > 0
                          ? 0.65
                          : 1,
                    }}
                  >
                    {formIsSaving ? <CircularProgress color="#fff" size={18} /> : 'Save Changes'}
                  </Button>
                  {/* {formIsLoading && <CircularProgress size={20} style={{ color: 'var(--jmi-blue)', marginLeft: 20 }} />} */}
                </div>
                <div className='flex-1 row-end-center'> 
                    {/* Single Qa mode */}
                    {/* <div className='flex-column'> 
                    <CardHeader
                      style={{ padding: 0 }}
                      titleTypographyProps={{ className: classes.cardHeaderTitle }}
                      title={
                        <FormControlLabel
                          label="Single QA Mode"
                          labelPlacement="start"
                          control={
                            <ColoredCheckbox
                              style={{ marginRight: 15 }}
                              checked={qaSingleSelectEnabled}
                              // onChange={toggleqaSingleSelectEnabled}
                            />
                          }
                        />
                      }
                    />
                    </div> */}
                    {/* Autofill the qa that is selected but be able to make it multi*/}
                    <div className='flex-1 col-start-start'>
                        <div
                        style={{
                            color: '#aaa',
                            fontSize: 15,
                            visibility: qaSingleSelectEnabled ? 'hidden' : 'visible',
                          }}>
                            {counter}
                        </div>
                        {/* {qaSingleSelectEnabled ? ( */}
                      {/* <Autocomplete
                        loading={clientOptionsLoading || productsLoading}
                        // options={clientOptions}
                        // onChange={setSelectedClient}
                        value={selectedQa}
                        placeholder={'Loading QA User'}
                        containerStyles={{ zIndex: 2 }}
                        maxHeight={'65px'}
                        disabled={true}
                        
                      /> */}

                      {/* <input type='text' value={selectedQa?.label} className={classes.textBox}
                      /> */}
                    {/* ) : (
                      <Autocomplete
                        loading={clientOptionsLoading || productsLoading}
                        options={clientOptions}
                        // onChange={val => setSelectedClients(val || [])}
                        value={selectedClients}
                        placeholder={'Select clients before continuing...'}
                        isMulti={true}
                        containerStyles={{ zIndex: 2 }}
                        closeMenuOnSelect={false}
                        components={{ ValueContainer }}
                        maxHeight={'65px'}
                      />
                    )} */}
                    </div>
                </div>
              </div>
            }
          />
        <div className='flex-row'> 
        <CardHeader
              titleTypographyProps={{ className: classes.cardHeaderTitle }}
              title={
                <div style={{ float: 'left' }} className="flex-1 row-start-start">
                  {!qaSingleSelectEnabled ? (
                    <FormControl>
                      <RadioGroup row 
                    //   onChange={changeUpdateState}
                      >
                        <InfoTooltip
                          title="Clear all override settings for selected clients and create new override settings."
                          placement="top-end"
                        >
                          <FormControlLabel
                            label="Create New"
                            labelPlacement="start"
                            value="Wipe"
                            control={<ColoredRadio />}
                            // disabled={qaSingleSelectEnabled}
                          />
                        </InfoTooltip>
                        <InfoTooltip
                          title="Update current override settings for selected clients and product (currently selected products will not be affected)"
                          placement="top-end"
                        >
                          <FormControlLabel
                            label="Update"
                            labelPlacement="start"
                            value="Update"
                            control={<ColoredRadio />}
                            // disabled={qaSingleSelectEnabled}
                            // checked={wipeUpdateCreate}
                          />
                        </InfoTooltip>
                      </RadioGroup>
                    </FormControl>
                  ) : (
                    <div className="row-start-end">
                      <FormControlLabel
                        control={
                          <ColoredCheckbox
                            onChange={toggleSelectProductEnabled}
                            checked={selectProduct}
                            disabled={!qaSingleSelectEnabled}
                          />
                        }
                        label={!supplementView ? 'Show Selected Products' : 'Show Selected Supplements'}
                        labelPlacement="start"
                      />
                    </div>
                  )}
                  {/* Show selected products only checkbox */}
                </div>
              }
            />
        </div>
          <CardContent
            className={classes.table}
            style={{
              pointerEvents: !formIsReady || formIsSaving ? 'none' : 'auto',
              opacity: formIsReady ? 1 : 0.5,
            }}
          >
            {/* First column - product types */}
            <div className={cn(classes.tableColumn)}>
              <div className={classes.tableColumnHeader}>Property Types</div>
              <div className={classes.columnListContainer}>
              {Object?.keys(filteredCategoryColumnData)
                    ?.filter(
                      type =>
                        !!Object.keys(filteredCategoryColumnData[type])?.filter(prod =>
                          filteredCategoryColumnData[type][prod]?.some(val =>
                            selectProduct ? validProductIds?.has(val.productId) : val,
                          ),
                        ).length,
                    )
                    ?.map(renderPropertyTypeCell)}
              </div>
            </div>

            {/* Second column - product categories */}
            <div
              className={cn(
                classes.tableColumn,
                //   selectedCategoryId === null && classes.columnDisabled
              )}
            >
              <div className={classes.tableColumnInputHeader}>
                <input
                  className={classes.inputHeader}
                  onChange={runCategoriesFilter} //? this.value == null : setFilteredColumnData(columnData)
                  id="productCategoriesFilter"
                  type="text"
                  placeholder="Product Categories"
                  onFocus={e => (e.target.placeholder = '')}
                  onBlur={e => (e.target.placeholder = 'Product Categories')}
                ></input>
                <SearchIcon className={classes.searchIcon} />
              </div>
              {!!selectedPropertyTypeId &&
                  Object?.keys(filteredCategoryColumnData[selectedPropertyTypeId])
                    ?.filter(prod =>
                      filteredCategoryColumnData[selectedPropertyTypeId][prod]?.some(val =>
                        selectProduct ? validProductIds?.has(val.productId) : val,
                      ),
                    )
                    ?.sort()
                    ?.map(renderProductCategoryCell)}
            </div>

            {/* Third column - products */}
            <div
              className={cn(
                classes.tableColumn,
                //   selectedProductId === null && classes.columnDisabled
              )}
            >
                <div className={classes.tableColumnInputHeader}>
                
                  <div className={classes.selectAll}>
                  {!!selectedPropertyTypeId && !!selectedProductCategoryId   && 
                  renderSelectAllCell(filteredNameColumnData[selectedPropertyTypeId][selectedProductCategoryId]
                  ?.filter(prod => (selectProduct ? validProductIds.has(prod.productId) : prod))
                  ?.sort((a, b) => a.productCode.localeCompare(b.productCode)))
                }
                  </div>
                  <input
                    className={classes.inputHeader}
                    onChange={runNameFilter}
                    id="productNameFilter"
                    type="text"
                    placeholder="Product Names"
                    onFocus={e => (
                      e.target.placeholder = '', setShowSelectAll(false)
                      )}
                    onBlur={e => (e.target.placeholder = 'Product Names', setShowSelectAll(true))}
                  ></input>
                  <SearchIcon className={classes.searchIcon} />
                </div>
                {!!selectedPropertyTypeId &&
                  !!selectedProductCategoryId &&
                  filteredNameColumnData[selectedPropertyTypeId][selectedProductCategoryId]
                    ?.filter(prod => (selectProduct ? validProductIds.has(prod.productId) : prod))
                    ?.sort((a, b) => a.productCode.localeCompare(b.productCode))
                    ?.map(renderProductNameCell)}
               
            </div>
          </CardContent>
        </Card>
      </Grid>
      
      {/* Confirmation Modal */}
      <ConfirmationDialog
        minHeight={'50vh'}
        minWidth={'60vw'}
        maxWidth={'xl'}
        visible={showSaveChangesModal}
        setVisibility={setSaveChangesModal}
        title={'Confirm Changes'}
        cancelButton={
          <Button onClick={() => setSaveChangesModal(false)} style={{ backgroundColor: '#F44336', color: 'white' }}>
            Cancel
          </Button>
        }
        acceptButton={
          <Button
            onClick={() => handleSaveChangesButton()}
            style={{
              backgroundColor: '#315382',
              color: 'white',
            }}
            disabled = {saveChanges}
          >
            {saveChanges ? <CircularProgress color="#fff" size={18} /> : 'Confirm Changes'}
            
          </Button>
        }
      >
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center" colSpan={2}>
                  {qaSingleSelectEnabled
                    ? 'Update permissions for ' + selectedQa?.label
                    : counter === 1 + ' selected'
                    }
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ fontWeight: 'bold' }}>Product</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Current Permissions</TableCell>
                
              </TableRow>
            </TableHead>
            <TableBody>
              {changes.validProducts?.map(row => (
                <TableRow>
                  <TableCell>
                    {row.productCode}
                    <div style={{ fontSize: '0.8em' }}>{row.productName}</div>
                  </TableCell>
                  <TableCell>{"Access Allowed"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
            
            
          </Table>
        </TableContainer>
      </ConfirmationDialog>
    </>
  );
});

// QaDetailRestrictionsTab.propTypes = {
//   classes: PropTypes.object.isRequired,
// };
